<template>
  <div class="animation-wrapper">
    <lottie
      :options="defaultOptions"
      @animCreated="handleAnimation"
    />
  </div>
</template>

<script>
import Vue from 'vue';
import lottie from 'vue-lottie';
import * as animationData from '@/assets/prompt-timer-animation.json'

export default Vue.extend({
  name: 'PromptTimerAnimation',
  components: {
    lottie
  },
  props: {
    duration: Number
  },
  data: () => ({
    defaultOptions: {
      animationData: animationData.default,
      loop: false
    }
  }),
  methods: {
    handleAnimation: function (anim) {
      anim.setSpeed(60 / (this.duration || 90));
    }
  }
})
</script>

<style scoped lang="scss">
.animation-wrapper {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 94%;
}
</style>
